import { useEffect, useState } from "react";
import { Box, SxProps } from "@mui/material";
import { MuiTelInput, MuiTelInputInfo } from "mui-tel-input";
import { CountryCode } from "libphonenumber-js";
import CustomLabel from "@/modules/common/components/input/custom-label";

interface CountryPhoneInputProps {
  onPhoneChange: (phone: string) => void;
  onCountryChange?: (country: string) => void;
  error?: boolean;
  helperText?: string;
  value?: string;
  size?: "small" | "medium";
  required?: boolean;
  placeholder?: string;
  label?: string;
  labelSx?: SxProps;
  defaultCountry?: string;
  disableDropdown?: boolean;
  excludedCountries?: string[];
  testId?: string;
}

export default function CountryPhoneInput({
  onPhoneChange,
  onCountryChange,
  error = false,
  helperText = "",
  value = "",
  size = "small",
  required,
  placeholder,
  label,
  labelSx,
  defaultCountry = "EG",
  disableDropdown = false,
  excludedCountries = [],
  testId,
}: CountryPhoneInputProps) {
  const [phone, setPhone] = useState(value);
  const [country, setCountry] = useState<CountryCode>(
    defaultCountry as CountryCode
  );

  useEffect(() => {
    if (value !== undefined) {
      setPhone(value);
    }
  }, [value]);

  const handlePhoneChange = (newPhone: string, info: MuiTelInputInfo) => {
    setPhone(newPhone);
    onPhoneChange(newPhone);

    if (info.countryCode) {
      setCountry(info.countryCode as CountryCode);
      if (onCountryChange) {
        onCountryChange(info.countryCode);
      }
    }
  };

  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
      {label && <CustomLabel sx={labelSx}>{label}</CustomLabel>}
      <MuiTelInput
        value={phone}
        onChange={handlePhoneChange}
        defaultCountry={country}
        error={error}
        helperText={helperText}
        fullWidth
        required={required}
        size={size}
        label={placeholder}
        forceCallingCode
        disableDropdown={disableDropdown}
        focusOnSelectCountry
        slotProps={{ htmlInput: { autoCapitalize: "none", "data-testid": testId } }}
        sx={{ "& .MuiOutlinedInput-root": { borderRadius: "8px" } }}
        excludedCountries={[...excludedCountries, "IL"] as CountryCode[]}
      />
    </Box>
  );
}
